(() => {
  if (customElements.get('navigation-mobile-slider')) {
    return;
  }

  class NavigationMobileSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.drawer = null;
      this.handleClick = null;
      this.handleDrawerClick = null;
    }

    connectedCallback() {
      this.initSlider();
      this.initTabNavigation();
    }

    disconnectedCallback() {
      // Clean up slider
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }

      // Clean up event listeners
      if (this.handleClick) {
        this.removeEventListener('click', this.handleClick);
        this.handleClick = null;
      }

      if (this.drawer && this.handleDrawerClick) {
        this.drawer.removeEventListener('click', this.handleDrawerClick);
        this.handleDrawerClick = null;
        this.drawer = null;
      }
    }

    initSlider() {
      const sliderElement = this.querySelector('[data-slider]');
      if (!sliderElement) return;

      const options = {
        slidesPerView: 2.5,
        spaceBetween: 10,
        freeMode: true,
        watchOverflow: true,
      };

      this.slider = new Swiper(sliderElement, options);
    }

    initTabNavigation() {
      // Handle tab link clicks
      this.handleClick = (e) => {
        const link = e.target.closest('a.header-drawer__nav-card-link');

        if (!link) return;

        const href = link.getAttribute('href');

        if (href && href.startsWith('#tab-')) {
          e.preventDefault();
          this.openTab(href);
        }
      };
      this.addEventListener('click', this.handleClick);

      // Handle back button clicks in tabs
      this.drawer = this.closest('header-drawer');
      if (this.drawer) {
        this.handleDrawerClick = (e) => {
          const backButton = e.target.closest('.header-drawer-tab__back');
          if (backButton) {
            e.preventDefault();
            this.closeTab(backButton);
          }
        };
        this.drawer.addEventListener('click', this.handleDrawerClick);
      }
    }

    openTab(tabId) {
      if (!this.drawer) return;

      const allTabs = this.drawer.querySelectorAll('.header-drawer-tab');
      allTabs.forEach(tab => tab.classList.remove('open'));

      const targetTab = this.drawer.querySelector(tabId);
      if (targetTab) {
        targetTab.classList.add('open');
      }
    }

    closeTab(backButton) {
      // Find the closest tab element
      const tab = backButton.closest('.header-drawer-tab');
      if (tab) {
        tab.classList.remove('open');
      }
    }
  }

  customElements.define('navigation-mobile-slider', NavigationMobileSlider);
})();

